module.exports = __webpack_public_path__ + "static/media/58.046704e6.jpg";